<script setup lang="ts">
defineProps({ blok: Object });
</script>

<template>
  <section class="relative py-20">
    <div
      class="absolute top-0 left-0 w-full h-[300px] bg-gradient-to-b from-chsc-raw to-transparent z-[-1]"
    />
    <UiContainer max-width="max-w-3xl">
      <header class="insight-category-header">
        <img :src="blok?.icon.filename" :alt="blok?.icon.alt" />
        <StoryblokRichText :doc="blok?.header" />
      </header>
    </UiContainer>
    <UContainer max-width="max-w-3xl">
      <div class="border-[2px] border-chsc-indigo-500 rounded-[40px] px-6 py-8">
        <p class="font-londrina-solid fs-5xl text-chsc-indigo-500 text-center">{{ blok?.claim }}</p>
      </div>
    </UContainer>

    <UiContainer max-width="max-w-2xl" class="mt-20">
      <div class="insighr-category-description mb-12">
        <StoryblokRichText :doc="blok?.description" />
      </div>
    </UiContainer>
  </section>
</template>
